import type { FiverrContext } from '@fiverr-private/fiverr_context';

type CountryCode = FiverrContext['countryCode'];

export const EXCLUDED_SELLERS_COUNTRIES_CODES: CountryCode[] = ['IN', 'BD', 'PK', 'ID', 'MA', 'NG', 'LK', 'KE'];
